import { render, staticRenderFns } from "./ReceivedItems.vue?vue&type=template&id=b90b9626&"
import script from "./ReceivedItems.vue?vue&type=script&lang=js&"
export * from "./ReceivedItems.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports